export default "__VITE_ASSET__e83c1825__"